import { createReducer } from 'reduxsauce';
import { isEqual, cloneDeep, filter } from 'lodash';

import { StatsTypes } from '../actions/stats.actions';

const initialState = {
  status: [],
  activityLevel: { driving_rank: 0, driving_total: 0, driving: [] },
  infractions: {
    infractions_rank: 0,
    infractions_total: 0,
    infractions: [],
  },
  infractionsDetails: {},
  missedOpportunities: [],
  spottedVehicles: { rank: 0, spottedVehicles: [] },
  repossessions: { rank: 0, repossessions: [] },
  hoursWorked: {
    rank: 0,
    total_hours_worked: 0,
    normal_shifts: {},
    extraneous_times: {},
  },
  commissions: {},
  day_shifts: [],
  day_extraneous_times: [],
};

const getMyActivityLevelRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-activity-level');

  return { ...state, activityLevel: initialState.activityLevel, status };
};
const getMyActivityLevelSuccess = (state, action) => {
  const activityLevel = action.response;
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-activity-level', a));

  return { ...state, activityLevel, status };
};
const getMyActivityLevelFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-activity-level', a));

  return { ...state, status };
};

const getMyInfractionsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-infractions');

  return { ...state, infractions: initialState.infractions, status };
};
const getMyInfractionsSuccess = (state, action) => {
  const infractions = action.response;
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-infractions', a));

  return { ...state, infractions, status };
};
const getMyInfractionsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-infractions', a));

  return { ...state, status };
};

const getInfractionsDetailsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-infractions-details');

  return {
    ...state,
    infractionsDetails: initialState.infractionsDetails,
    status,
  };
};
const getInfractionsDetailsSuccess = (state, action) => {
  const infractionsDetails = action.response;
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-infractions-details', a));

  return { ...state, infractionsDetails, status };
};
const getInfractionsDetailsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-infractions-details', a));

  return { ...state, status };
};

const getMySpottedVehiclesRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-spotted-vehicles');

  return { ...state, spottedVehicles: initialState.spottedVehicles, status };
};
const getMySpottedVehiclesSuccess = (state, action) => {
  const spottedVehicles = action.response;
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-spotted-vehicles', a));

  return { ...state, spottedVehicles, status };
};
const getMySpottedVehiclesFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-spotted-vehicles', a));

  return { ...state, status };
};

const getMyRepossessionsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-repossessions');

  return { ...state, repossessions: initialState.repossessions, status };
};
const getMyRepossessionsSuccess = (state, action) => {
  const repossessions = action.response;
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-repossessions', a));

  return { ...state, repossessions, status };
};
const getMyRepossessionsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-repossessions', a));

  return { ...state, status };
};

const getMyHoursWorkedRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-hours-worked');

  return { ...state, hoursWorked: initialState.hoursWorked, status };
};
const getMyHoursWorkedSuccess = (state, action) => {
  const hoursWorked = action.response;
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-hours-worked', a));

  return { ...state, hoursWorked, status };
};
const getMyHoursWorkedFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-hours-worked', a));

  return { ...state, status };
};

const getDayShiftsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-day-shifts');

  return { ...state, day_shifts: [], status };
};
const getDayShiftsSuccess = (state, action) => {
  const dayShifts = action.response;
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-day-shifts', a));

  return { ...state, day_shifts: dayShifts, status };
};
const getDayShiftsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-day-shifts', a));

  return { ...state, status };
};

const getDayExtraneousTimesRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-day-extraneous-times');

  return { ...state, day_extraneous_times: [], status };
};
const getDayExtraneousTimesSuccess = (state, action) => {
  const dayExtraneousTimes = action.response;
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-day-extraneous-times', a));

  return { ...state, day_extraneous_times: dayExtraneousTimes, status };
};
const getDayExtraneousTimesFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-day-extraneous-times', a));

  return { ...state, status };
};

const getMyCommissionsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-commissions');

  return { ...state, commissions: initialState.commissions, status };
};
const getMyCommissionsSuccess = (state, action) => {
  const commissions = action.response;
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-commissions', a));

  return { ...state, commissions, status };
};
const getMyCommissionsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-commissions', a));

  return { ...state, status };
};

const getMyMissedOpportunitiesRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-missed-opportunities');

  return {
    ...state,
    missedOpportunities: initialState.missedOpportunities,
    status,
  };
};
const getMyMissedOpportunitiesSuccess = (state, action) => {
  const missedOpportunities = action.response;
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-missed-opportunities', a));

  return { ...state, missedOpportunities, status };
};
const getMyMissedOpportunitiesFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-missed-opportunities', a));

  return { ...state, status };
};

const clearStatsRequest = (state) => ({ ...state, ...initialState });

export const reducer = createReducer(initialState, {
  [StatsTypes.GET_MY_ACTIVITY_LEVEL_REQUEST]: getMyActivityLevelRequest,
  [StatsTypes.GET_MY_ACTIVITY_LEVEL_SUCCESS]: getMyActivityLevelSuccess,
  [StatsTypes.GET_MY_ACTIVITY_LEVEL_FAILURE]: getMyActivityLevelFailure,

  [StatsTypes.GET_MY_INFRACTIONS_REQUEST]: getMyInfractionsRequest,
  [StatsTypes.GET_MY_INFRACTIONS_SUCCESS]: getMyInfractionsSuccess,
  [StatsTypes.GET_MY_INFRACTIONS_FAILURE]: getMyInfractionsFailure,

  [StatsTypes.GET_INFRACTIONS_DETAILS_REQUEST]: getInfractionsDetailsRequest,
  [StatsTypes.GET_INFRACTIONS_DETAILS_SUCCESS]: getInfractionsDetailsSuccess,
  [StatsTypes.GET_INFRACTIONS_DETAILS_FAILURE]: getInfractionsDetailsFailure,

  [StatsTypes.GET_MY_SPOTTED_VEHICLES_REQUEST]: getMySpottedVehiclesRequest,
  [StatsTypes.GET_MY_SPOTTED_VEHICLES_SUCCESS]: getMySpottedVehiclesSuccess,
  [StatsTypes.GET_MY_SPOTTED_VEHICLES_FAILURE]: getMySpottedVehiclesFailure,

  [StatsTypes.GET_MY_REPOSSESSIONS_REQUEST]: getMyRepossessionsRequest,
  [StatsTypes.GET_MY_REPOSSESSIONS_SUCCESS]: getMyRepossessionsSuccess,
  [StatsTypes.GET_MY_REPOSSESSIONS_FAILURE]: getMyRepossessionsFailure,

  [StatsTypes.GET_MY_HOURS_WORKED_REQUEST]: getMyHoursWorkedRequest,
  [StatsTypes.GET_MY_HOURS_WORKED_SUCCESS]: getMyHoursWorkedSuccess,
  [StatsTypes.GET_MY_HOURS_WORKED_FAILURE]: getMyHoursWorkedFailure,

  [StatsTypes.GET_DAY_SHIFTS_REQUEST]: getDayShiftsRequest,
  [StatsTypes.GET_DAY_SHIFTS_SUCCESS]: getDayShiftsSuccess,
  [StatsTypes.GET_DAY_SHIFTS_FAILURE]: getDayShiftsFailure,

  [StatsTypes.GET_DAY_EXTRANEOUS_TIMES_REQUEST]: getDayExtraneousTimesRequest,
  [StatsTypes.GET_DAY_EXTRANEOUS_TIMES_SUCCESS]: getDayExtraneousTimesSuccess,
  [StatsTypes.GET_DAY_EXTRANEOUS_TIMES_FAILURE]: getDayExtraneousTimesFailure,

  [StatsTypes.GET_MY_COMMISSIONS_REQUEST]: getMyCommissionsRequest,
  [StatsTypes.GET_MY_COMMISSIONS_SUCCESS]: getMyCommissionsSuccess,
  [StatsTypes.GET_MY_COMMISSIONS_FAILURE]: getMyCommissionsFailure,

  [StatsTypes.GET_MY_MISSED_OPPORTUNITIES_REQUEST]: getMyMissedOpportunitiesRequest,
  [StatsTypes.GET_MY_MISSED_OPPORTUNITIES_SUCCESS]: getMyMissedOpportunitiesSuccess,
  [StatsTypes.GET_MY_MISSED_OPPORTUNITIES_FAILURE]: getMyMissedOpportunitiesFailure,

  [StatsTypes.CLEAR_STATS_REQUEST]: clearStatsRequest,
});
